module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-simple-analytics@1.0.4/node_modules/gatsby-plugin-simple-analytics/gatsby-browser.js'),
      options: {"plugins":[],"events":true,"eventsGlobal":"sa_event","ignorePages":[],"trackPageViews":true},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react-dom@19.2.5_react@19.2.5__react@1_c5f6003ef58b08bc06d1cea2c799368c/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
